import $ from "jquery";

var ltIE8 = /MSIE [1-7]\b/.test(navigator.userAgent);
var minWidthKey = "ui-tabcontrol.min-width";
var hideTextKey = "ui-tabcontrol.hideText";

function delayedRunOnResize(f) {
	var t = 0, w = $(window), thisWidth, prevWidth = w.width();
	$(window).on("resize", function() {
		if(t !== 0) clearTimeout(t);
		t = setTimeout(function() {
			t = 0;
			thisWidth = w.width();
			if(prevWidth != thisWidth) {
				prevWidth = thisWidth;
				f();
			}
		}, 100);
	});
	f();
}

function findCutOff(items, fullWidth, cutOff) {
	var i = items.length;
	for(var j = 0, p = 0; j < items.length; j++) {
		var item = $(items[j]);
		p += item.data(minWidthKey);
		if(p >= cutOff) {
			// i is the first one that does not fit 
			// assuming chevron is on screen
			i = Math.min(i, j);
			if(p >= fullWidth)
				break;
			else if(j == items.length - 1) // all fit
				i = j + 1;
		}
	}
	return i;
}

/*
function dumpItems(items) {
	var r = [];
	items.each(function() { r.push(this.innerText); });
	return r;
}
*/

function preProcessItems(items, hideText) {
	return items.each(function() {
		var item = $(this);
		var hideItemText = item.data(hideTextKey);
		item.find(">a").toggleClass("ui-icon-only", hideText && hideItemText)
			.find(">span").toggleClass("ui-icontext", hideText && hideItemText);
	});
}

function resizeSingleRow(me, items, chevron, chevronWidth) {
	return function() {
		$("ul.ui-menu", chevron).hide();
		items.detach();
		chevron.detach();
		var fullWidth = me.width(), cutOff = fullWidth - chevronWidth;
		var activeTab = items.filter(".active");
		var activeIndex = items.index(activeTab);
		if(!ltIE8) items.css("max-width", cutOff);
		// i is the first that is offscreen
		var i = findCutOff(items, fullWidth, cutOff);
		var remain;
		if(i < activeIndex) // active tab is off?
		{
			// decrease width and try again
			cutOff -= activeTab.data(minWidthKey);
			i = findCutOff(items, fullWidth, cutOff);
			me.append(preProcessItems(items.slice(0, i), true))
				.append(preProcessItems(activeTab, true));
			remain = items.slice(i, activeIndex).add(items.slice(activeIndex + 1));
			i++;
		}
		else {
			if(i === 0) i++;
			me.append(preProcessItems(items.slice(0, i), true));
			remain = items.slice(i);
		}
		// i is the first that does not fit
		if(i < items.length) {
			var hasIcons = false;
			remain.each(function() {
				if($(this).find(">a").hasClass("ui-icon-custom")) {
					hasIcons = true;
					return false;
				}
			});
			chevron.appendTo(me).css("display", "").find(">a span.ui-icontext > span").text(remain.length);
			$("ul.ui-menu", chevron).empty().toggleClass("td-hasicons", hasIcons).append(preProcessItems(remain, false)).menu("refresh");
		}
	};
}

function initSingleRow(me, options) {
	options = $.extend({ moreText: "More" }, options);
	me = $(me).css({ "white-space": "nowrap" });
	var items = me.children("li").each(function() {
		var item = $(this);
		var hideText = item.find(">a").hasClass("ui-icon-only");
		item.data(hideTextKey, hideText);
		if(!hideText) $("span.ui-icontext", item).toggleClass("ui-icontext", false);
		item.data(minWidthKey, item.outerWidth(true));
	});
	var linkId = "ui-tab-chevron-a-" + new Date().valueOf();
	var chevron = $("<li class=\"ui-tab-chevron\">")
		.append($("<a id=\"" + linkId + "\" href=\"#\" class=\"ui-icon-drop\"><span class=\"ui-icontext\">&#160;" + options.moreText + "&#160;(<span>" + items.length + "</span>)</span></a>"))
		.appendTo(me)
		.append($("<ul>", { "class": "ui-menu ui-popup" }).menu().popup("#" + linkId, { my: "right top", at: "right bottom" }));
	var cw = chevron.outerWidth(true);
	chevron.hide();
	var refresher = resizeSingleRow(me, items, chevron, cw);
	me.data("ui-tabs.refresher", refresher);
	delayedRunOnResize(refresher);
}

$.fn.tabControl = function(options) {
	if(options === "refresh")
		return this.each(function() {
			$(this).data("ui-tabs.refresher")();
		});

	options = $.extend({}, options);
	return this.each(function() { initSingleRow(this, options); });
};

